<template>
  <div class="video-page">
    <vimeo-video :id="$route.params.id">
   <template slot-scope="props">
        <article class="page" v-if="props.video">
          <div v-html="props.video.iframeCode"></div>
          <div class="spacer"></div>
          <h2 class="title main-head-title">{{ props.video.name }}</h2>
          <!-- PAGE INFO -->
          <div class="page-info">
            <div class="metabox">
              <span class="meta-i"><i class="fa fa-clock-o"></i>{{ props.video.date }}</span>
              <span class="meta-i"><a :href="props.video.link" target="_blank"><i class="fa fa-external-link"></i> Voir sur Vimeo</a></span>
            </div>
            <ul class="social">
              <li class="social-facebook"><a href="#" class="fa fa-facebook social-icons"></a></li>
              <li class="social-google-plus"><a href="#" class="fa fa-google-plus social-icons"></a></li>
              <li class="social-twitter"><a href="#" class="fa fa-twitter social-icons"></a></li>
              <li class="social-youtube"><a href="#" class="fa fa-youtube social-icons"></a></li>
              <li class="social-rss"><a href="#" class="fa fa-rss social-icons"></a></li>
            </ul>
          </div>
          <div class="clearfix spacer"></div>
          <!-- DETAILS -->
          <div class="video-content">
            <h2 class="title main-head-title">Description</h2>
            <img :src="props.video.pictures.sizes[2].link" class="video-thumbnail" align="left">
            <div v-if="props.video.description">
              <p v-for="text in props.video.description.split('\n')">
                {{ text }}<br>
              </p>
            </div>
          </div>
          <div class="clearfix spacer"></div>
        </article>
      </template>
    </vimeo-video>
  </div>
</template>

<script>
  import { VimeoVideo } from 'itrnews-vuejs-api';

  export default {
    components: { VimeoVideo },
    name: 'VideoPage',
  };
</script>

<style scoped>
  .video-thumbnail {
    padding: 0 15px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoPage.vue